const TOLSTOY_WEBSITE_BASE_URL = 'https://www.gotolstoy.com';

export const TOLSTOY_TERMS_OF_USE = `${TOLSTOY_WEBSITE_BASE_URL}/terms-of-use`;
export const TOLSTOY_PRIVACY_POLICY = `${TOLSTOY_WEBSITE_BASE_URL}/privacy-policy`;
/** Note: the Avatar Use policy also incorporates the general Tolstoy Terms of Use. */
export const BUNU_TERMS_OF_USE = `${TOLSTOY_WEBSITE_BASE_URL}/tolstoy-avatar-use-policy`;

export const TOLSTOY_APP_AI_VIDEO_LIBRARY = `${process.env.NEXT_PUBLIC_APP_BASE_URL}/videos/aiVideo`;
export const TOLSTOY_APP_SHOP = `${process.env.NEXT_PUBLIC_APP_BASE_URL}/shop-app`;

export const SHOPIFY_TOLSTOY_APP = 'https://apps.shopify.com/tolstoy';

export const CALENDLY_LINK = 'https://calendly.com/gotolstoy/30min';

export const BUNU_SHOPIFY_APP_LINK = 'https://apps.shopify.com/studio-ai-videos';
